'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var placeHeaderBehindNav = exports.placeHeaderBehindNav = function placeHeaderBehindNav() {
  var root = document.documentElement;
  var header = document.querySelector('header');
  var headerHeight = header.clientHeight;

  if (header) {
    root.style.setProperty('--header-height', headerHeight + "px");
  }

  window.addEventListener('resize', function (event) {
    if (header) {
      headerHeight = header.clientHeight;
      root.style.setProperty('--header-height', headerHeight + "px");
    }
  });
};